import Pagination from 'rc-pagination';
import { orderBy } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button, Col, Container, FormGroup, Input, Row } from 'reactstrap';
import { getCompanies } from '../actions/Companies';
import SpinnerCircles from '../components/Spinner/Spinner';
import {
  addNumber,
  assignCompanyNumberCancel,
  assignCompanyNumberShow,
  assignNumberShow,
  assignNumberToUser,
  cancelAddNumber,
  cancelAssignNumber,
  editNumberCancel,
  editNumberShow,
  filterByNumber,
  filterNumbersByCompany,
  filterPagination,
  getCompanyNumbers,
  getNumbers,
  getUserNumbers,
  revokeUserNumberCancel,
  revokeUserNumberShow,
  setActiveNumbersTab,
  showAddNumber,
  updateNumber,
  updateObiByNumber,
  filterByEmail,
  addBulkNumber,
  editNumberFieldChange as editNumberFieldChangeAction,
  deleteNumberById,
  getNumberFeaturesByID,
  forceUnlinkNumberFromBox,
  updateBulkNumbers,
  uploadAgreementFile,
} from '../actions/Numbers';
import Breadcrumbs from '../components/Breadcrumb';
import CompanyAutocomplete from '../components/CompanyAutocomplete';
import AddNumberModal from '../components/Numbers/AddNumberModal';
import AllNumbersList from '../components/Numbers/AllNumbersList';
import EditNumberModal from '../components/Numbers/EditNumberModal';
import DropdownSelect from '../components/ProposalGenerator/DropdownSelect';
import SetLimitEntries from '../components/SetLimitEntries';
import WithUserData from '../HOC/withUserData';
import FilterIcon from '../Res/Icon/filter.png';
import NumbersIcon from '../Res/Icon/Number-list.png';
import './Numbers.css';
import UsersAutocomplete from '../components/UserAutocomplete';
import { assignRouteInfo, getGateways, updateNumberRoute } from '../actions/Provisioning';
import AddSecurityCodeModal from '../components/AddSecurityCodeModal';
import { ENG_LOCALE } from '../lib/constants';
import { getTrunkGroupList } from '../actions/Inteliquent';
import NumberChangeLog from '../components/Numbers/NumberChangeLog';
import { addSystemLogs } from '../actions/SystemLogs';
import CustomWarning from '../components/CustomWarning';
import { getPermissionForComponent } from '../utils/permissionsUtils';
import WarningModal from '../components/WarningModal';
import { toast } from 'react-toastify';

const dropdownOptions = [
  { label: 'All', value: 'all' },
  { label: 'Alarm', value: 'alarm' },
  { label: 'Dialout', value: 'dialout' },
  { label: 'Elevator', value: 'elevator' },
  { label: 'Fire Alarm', value: 'fireAlarm' },
  { label: 'Fax', value: 'fax' },
  { label: 'Fax Standard', value: 'faxStandard' },
  { label: 'Hunt', value: 'hunt' },
  { label: 'Page', value: 'page' },
  { label: 'PRI', value: 'pri' },
  { label: 'Modem', value: 'modem' },
  { label: 'OOB', value: 'oob' },
  { label: 'Ringdown', value: 'ringDown' },
  { label: 'Secure Entry', value: 'secureEntry' },
  { label: 'Voicemail', value: 'vmail' },
  { label: 'Voice', value: 'voice' },
  { label: 'Call ID Mask', value: 'callIdMask' },
  { label: 'Unassigned', value: 'unassigned' },
  { label: 'Toll Free', value: 'tollFree' },
];
const carrierOptions = [
  { label: 'All', value: 'All' },
  { label: 'Inteliquent', value: 'inteliquent' },
  { label: 'VoiceTel', value: 'voicetel' },
  { label: 'TDM', value: 'tdm' },
  { value: 'verizontdm', label: 'Verizon TDM' },
  { value: 'verizonsip', label: 'Verizon SIP' },
  { value: 'telnyx', label: 'Telnyx' },
  { value: 'iqtollfree', label: 'IQ Toll-Free' },
  { value: 'nonepikline', label: 'Non EPIK Line' },
  { value: 'skyt', label: 'Skyetel' },
];
const yesNoOptions = [
  { label: '--', value: '' },
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];
const filterOptions = ['By Company', 'By Number', 'By Carrier', 'By Temp DID'];

const bulkUnAssignMsg = `WARNING: This action will move the selected numbers from the current company and 
                        EPIK Device to an unassigned status. The EPIK device ports will be unusable until a 
                        new number is provisioned. Are you sure you want to proceed?`

const UnAssignMsg =  `This will unassign the number from the company and will be nonassignable to an EPIK
                          Edge Device until reassigned. Are you sure you want to proceed?`

class Numbers extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    this.onAddNumber = this.onAddNumber.bind(this);
    this.onEditNumber = this.onEditNumber.bind(this);
    this.onAssignToUser = this.onAssignToUser.bind(this);

    this.state = {
      filterBy:
        props.user.role === 'superAdmin' ||
          props.user.role === 'supportEngineer' ||
          props.user.role === 'companyGroupAdmin' ||
          props.user.role === 'companyGroupManager'
          ? 'By Company'
          : 'By Number',
      filterNumberValue: '',
      selectStatus: dropdownOptions[0],
      carrierStatus: carrierOptions[0],
      selectedCompany: '',
      selectedTempDID: '',
      isLoading: true,
      sort: {
        name: '',
        order: '',
      },
      modalStatus: false,
      isNumbeDeleteSecurietyType: null,
      isShowLog: false,
      showLogNumber: null,
      warningModal: false,
      selectedNumbers: [],
      selectAllChecked: false,
      selectedBulkAction: '',
      numberBulkActionsAccess: false,
      originalNumber:null
    };
    this.pageNumber = 1;
    this.editRouteReq = {
      token: null,
    };
  }
  

  async componentDidMount() {
    const { filter, pagination, user } = this.props;
    const { selectStatus } = this.state;
    const paginOptions = pagination ? pagination : null;
    const filterByCompany = filter ? filter.suggestion._id : null;
    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      await this.props.getCompanies(this.token, undefined, 'yes');
      await this.props.getGateways(this.token);
      await this.props.getTrunkGroupList(this.token);
      await this.props.getNumbers(this.token, paginOptions, filterByCompany, selectStatus.value);
    } else {
      await this.props.getNumbers(this.token, paginOptions, user.company._id, selectStatus.value);
    }
    this.setState({ isLoading: false });
    const numberBulkActionsAccessPermission = getPermissionForComponent('numberBulkActionsAccess',user.permissionsGroup);
    this.setState({ numberBulkActionsAccess: numberBulkActionsAccessPermission })

  }

   componentDidUpdate(prevProps) {
    if (
      prevProps?.numbers !== this.props?.numbers ||
      prevProps?.pagination?.page !== this.props?.pagination?.page ||
      prevProps?.pagination?.limit !== this.props?.pagination?.limit
    ) {
      this.setState({ selectedNumbers: [], selectAllChecked: false });
    }
  }

  onDownload(id) {
    this.props.downloadFax(this.token, id);
  }

  async onDelete() {
    this.props.deleteFax(this.token, this.props.deleteFaxID);
  }

  async onAddNumber(e, fileDetails) {
    const addedNumber = {
      ...this.props.addedNumber,
      carrier: this.props.addedNumber.carrier?.value || "inteliquent"
    };
    const { pagination, filter, user, boxDetails, addSystemLogs } = this.props;
    const { selectStatus } = this.state;
    const paginOptions = pagination ? pagination : null;
    const filterByCompany = filter ? filter.suggestion._id : null;
    const reg = !boxDetails.myEpik
      ? /{sip_h_X-Epik-Call-Type=fax,sip_h_X-Epik-Uri=user\/port[0-9]}\user\/.*/m
      : /user\/.*\.[1-9]/m;

    if (!addedNumber.assignedTo) {
      delete addedNumber.assignedTo;
    }

    if (reg.test(addedNumber.forwardUris[0]) && addedNumber.obiNumber) {
      const res = await this.props.updateObiByNumber(this.token, addedNumber.obiNumber, {
        number: addedNumber.number,
        // assignedNumberRef: addedNumber._id || '',
        port: addedNumber.port,
        type: addedNumber.type,
        assignedNumberRef: addedNumber._id,
        rebootRequired: boxDetails.inhouseProvision,
      });
      if (res) {
        const body = {
          actionType: 'system',
          description: ` Port ${addedNumber?.port} assigned to Number ${addedNumber?.number} `,
        };
        await addSystemLogs(this.token, body);
      }
    }

    if (addedNumber.type === 'dialout') {
      if (addedNumber.spoofIncomingCid) {
        var val = addedNumber.cidOverride.substring(
          addedNumber.cidOverride.length - parseInt(addedNumber.numDigits),
        );
        if (addedNumber.spoofType === 'prepend') {
          addedNumber['cidOverride'] = val + '[callingNum]';
        }
        if (addedNumber.spoofType === 'append') {
          addedNumber['cidOverride'] = '[callingNum]' + val;
        }
      }
    }

    const token = localStorage.getItem('jwtToken') || null;

    let res = null;
    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      res = await this.props.addNewNumber(
        token,
        user._id,
        addedNumber,
        paginOptions,
        filterByCompany,
        selectStatus.value,
      );
    } else {
      res = await this.props.addNewNumber(
        token,
        user._id,
        addedNumber,
        paginOptions,
        user.company._id,
        selectStatus.value,
      );
    }
    if (res && fileDetails) {
      try {
        const formData = new FormData();
        formData.append('agreement', fileDetails);
        await this.props.uploadAgreementFile(token, res._id, formData);

        let fileExtension = ''; //file extension

        if (fileDetails.type) {
          if (fileDetails.type.includes('application/pdf')) {
            fileExtension = 'pdf';
          } else if (fileDetails.type.includes('application/msword')) {
            fileExtension = 'doc';
          } else if (fileDetails.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
            fileExtension = 'docx';
          }
        }
        const fileUpload = {
          actionType: 'system',
          description: `User ${user?.name} uploaded '<a id=${res._id} href=#>Agreement.${fileExtension}</a>' file for Caller ID Masking number ${addedNumber?.number} `,
        };
        await addSystemLogs(this.token, fileUpload);


        const body = {
          actionType: 'system',
          description: `Number ${addedNumber?.number} added by User: ${user?.email} `,
        };
        await addSystemLogs(this.token, body);
      } catch (e) {
        console.log('Error during file upload:', e);
      }
    } else if (res) {
      // If no attachment exists
      const body = {
        actionType: 'system',
        description: `Number ${addedNumber?.number} added by User: ${user?.email} `,
      };
      await addSystemLogs(this.token, body);
    }
  }

  async onAssignToUser() {
    const { user, number } = { ...this.props.assignedUser };
    const token = localStorage.getItem('jwtToken') || null;
    this.props.assignToUser(token, number, user);
  }

  async onEditNumber() {
    const changedNumber = { ...this.props.editedNumber };
    const originalNumber = this.state.originalNumber;
    const companyNameOriginal= originalNumber?.company?.name
    const { pagination, filter, user, boxDetails, addSystemLogs } = this.props;
    const { selectStatus, filterNumberValue } = this.state;
    const paginOptions = pagination ? pagination : null;
    const filterByCompany = filter ? filter.suggestion._id : null;
    const reg = !boxDetails.myEpik
      ? /{sip_h_X-Epik-Call-Type=fax,sip_h_X-Epik-Uri=user\/port[0-9]}\user\/.*/m
      : /user\/.*\.[1-9]/m;
    if (!changedNumber.assignedTo) {
      delete changedNumber.assignedTo;
    }
    if (changedNumber.cid === '') {
      delete changedNumber.cid;
    }
    const currentNumber = changedNumber.number
    const companyName = changedNumber.companyName
    const companyId = changedNumber.company
    const companyIdOriginal =originalNumber?.company?._id

    delete changedNumber.dateCreated;
    delete changedNumber.companyID;
    delete changedNumber.companyName;

    if (reg.test(changedNumber.forwardUris[0])) {
      const res = await this.props.updateObiByNumber(this.token, changedNumber.obiNumber, {
        number: changedNumber.number,
        // assignedNumberRef: changedNumber._id || '',
        port: changedNumber.port,
        type: changedNumber.type,
        assignedNumberRef: changedNumber._id,
        rebootRequired: boxDetails.inhouseProvision,
      });
      if (res) {
        const body = {
          actionType: 'system',
          description: ` Port ${changedNumber?.port} assigned to Number ${currentNumber} `,
        };
        await addSystemLogs(this.token, body);
      }

      // await addSystemLogs(this.token, body);
    } else {
      delete changedNumber.number;
    }
    if (changedNumber.type === 'dialout') {
      if (changedNumber.spoofIncomingCid) {
        var val = changedNumber.cidOverride.substring(
          changedNumber.cidOverride.length - parseInt(changedNumber.numDigits),
        );
        if (changedNumber.spoofType === 'prepend') {
          changedNumber['cidOverride'] = val + '[callingNum]';
        }
        if (changedNumber.spoofType === 'append') {
          changedNumber['cidOverride'] = '[callingNum]' + val;
        }
      }
    }
    const token = localStorage.getItem('jwtToken') || null;
    let res = '';
    if (this.editRouteReq.token !== null) {
      changedNumber['routeInfo'] = this.editRouteReq.body.routeInfo;
      await this.props.updateNumberRoute(
        this.editRouteReq.token,
        this.editRouteReq.id,
        this.editRouteReq.body,
      );
    }
    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      if (filterNumberValue !== '') {
        let type = 'By Number';
        res = await this.props.editNumber(
          token,
          changedNumber,
          paginOptions,
          filterNumberValue,
          type,
        );
      } else {
        res = await this.props.editNumber(
          token,
          changedNumber,
          paginOptions,
          filterByCompany,
          selectStatus.value,
        );
      }
    } else {
      res = await this.props.editNumber(
        token,
        changedNumber,
        paginOptions,
        user.company._id,
        selectStatus.value,
      );
    }

    if (res) {
      if (companyIdOriginal != companyId) {
        const body = {
          actionType: 'system',
          description: `Number ${currentNumber} assigned to company from ${companyNameOriginal} to ${companyName}. Database ID: ${companyIdOriginal} `,
        };
        await addSystemLogs(this.token, body);
      }
      else {
        const body = {
          actionType: 'system',
          description: `Number ${currentNumber} assigned to company ${companyName}. Database ID: ${companyId}.`,
        };
        await addSystemLogs(this.token, body);
      }
    }
    this.setState({ modalStatus: false });
  }

  onUnassignNumber = async () => {
    const { pagination, editedNumber, editNumber } = this.props;
    this.setState({ isLoading: true });
    const changedNumber = { ...editedNumber };
    changedNumber.company = null;
    const paginOptions = pagination || null;
    const type = 'all';
    const res = await editNumber(this.token, changedNumber, paginOptions, null, type);
    if (res) {
      const body = {
        actionType: 'system',
        description: `Number ${changedNumber?.number} is Unassigned `,
      };
      await addSystemLogs(this.token, body);
    }
    this.setState({
      modalStatus: false,
      warningModal: false,
      isLoading: false,
      unassignSecurity: false,
    });
  };

  onSecurityModal = async () => {
    this.setState({ unassignSecurity: true });
  };

  onBulkConfirm = async e => {
    this.props.addNumberCancel();

    let res = await this.props.addBulkNumber(this.token, {
      numberArr: e,
    });
    if (res) {
      this.componentDidMount();
    }
  };

  handleSetLimit = async limit => {
    const { numbers, getNumbers, filterPagination, filter, user, filterByNumber } = this.props;
    const { selectStatus, filterNumberValue } = this.state;
    const filterByCompany = filter ? filter.suggestion._id : null;
    filterPagination({ page: numbers.allNumbers.page, limit: +limit });
    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      if (filterNumberValue !== '') {
        await filterByNumber(this.token, filterByCompany, filterNumberValue, {
          page: numbers.allNumbers.page,
          limit: +limit,
        });
      } else {
        await getNumbers(
          this.token,
          { page: numbers.allNumbers.page, limit: +limit },
          filterByCompany,
          selectStatus.value,
        );
      }
    } else {
      await this.props.getNumbers(
        this.token,
        { page: numbers.allNumbers.page, limit: +limit },
        user.company._id,
        selectStatus.value,
      );
    }
  };

  handleChangePagination = async numPage => {
    const { numbers, getNumbers, filterPagination, filter, user, filterByNumber } = this.props;
    const { selectStatus, filterNumberValue, selectedTempDID } = this.state;
    const filterByCompany = filter ? filter.suggestion._id : null;
    this.pageNumber = numPage;
    filterPagination({ page: numPage, limit: numbers.allNumbers.limit });
    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      if (filterNumberValue !== '') {
        await filterByNumber(this.token, filterByCompany, filterNumberValue, {
          page: numPage,
          limit: numbers.allNumbers.limit,
        });
      } else {
        await getNumbers(
          this.token,
          { page: numPage, limit: numbers.allNumbers.limit },
          filterByCompany,
          selectStatus.value,
          null,
          selectedTempDID
        );
      }
    } else {
      await getNumbers(
        this.token,
        { page: numPage, limit: numbers.allNumbers.limit },
        user.company._id,
        selectStatus.value,
      );
    }
  };
  onDeleteNumber = number => {
    this.setState({ modalStatus: false, isNumbeDeleteSecurietyType: null });
    const { pagination, filter } = this.props;
    const { selectStatus } = this.state;
    this.props.deleteNumberById(
      this.token,
      number._id,
      number.number,
      pagination,
      filter,
      selectStatus.value,
    );
  };
  onFilterByCompany = async company => {
    this.setState({ selectStatus: 'all' });
    const { filterNumbersByCompany, getNumbers, pagination, getCompanyNumbers } = this.props;
    const paginOptions = pagination ? pagination : null;
    if (company.suggestion) {
      if (Object.keys(company.suggestion).length === 0) {
        await getNumbers(this.token, undefined, 'none', 'all');
      } else {
        this.setState({ selectedCompany: company });
        await getNumbers(this.token, undefined, company.suggestion._id, 'all');
        await getCompanyNumbers(this.token, company.suggestion._id, true, 'none');
        await filterNumbersByCompany(company);
      }
    } else {
      this.setState({ selectedCompany: '' });
      await filterNumbersByCompany(null);
      await getNumbers(this.token, paginOptions, null, 'all');
    }
  };

  onUserTypeSelect = async ({ suggestion }) => {
    const {
      filterByEmail,
      getNumbers,
      getCompanyNumbers,
      filterNumbersByCompany,
      pagination,
    } = this.props;
    const paginOptions = pagination ? pagination : null;
    if (suggestion !== null) {
      await filterByEmail(this.token, suggestion.email, paginOptions);
    } else {
      await getNumbers(this.token, undefined, this.state.selectedCompany.suggestion._id, 'all');
      await getCompanyNumbers(this.token, this.state.selectedCompany.suggestion._id, true, 'none');
      await filterNumbersByCompany(this.state.selectedCompany);
    }
  };

  textSearchFilter = async number => {
    const { filterByNumber, user, pagination, filterBy, filter } = this.props;
    const filterByCompany = filter ? filter.suggestion._id : user.company._id;
    const { selectStatus } = this.state;
    const paginOptions = pagination
      ? { page: selectStatus.value === 'all' ? pagination.page : 1, limit: pagination.limit }
      : null;
    if (filterBy === 'By Number');
    this.setState({ filterNumberValue: number }, async () => {
      await filterByNumber(this.token, filterByCompany, number, paginOptions);
    });
  };

  onSelectTempDID = (selectedOption) => {
    const { value } = selectedOption;
    const { getNumbers } = this.props;
    getNumbers(this.token, null, null, 'all', null, value);
    this.setState({ selectedTempDID: value });
  };

  selectSearchFilter = async e => {
    this.setState({ filterBy: e });
    const { filter, pagination } = this.props;
    const { selectStatus } = this.state;
    const paginOptions = pagination ? pagination : null;
    const filterByCompany = filter ? filter.suggestion._id : null;
    if (e === 'By Company') {
      this.setState({ filterNumberValue: '' });
      await this.props.getNumbers(this.token, paginOptions, filterByCompany, selectStatus.value);
    } else {
      await this.props.getNumbers(this.token, paginOptions, null, selectStatus.value);
    }
    this.setState({ selectStatus: 'all' });
  };

  onStatusSortSelect = async (selectedOption, carrierOption = {}) => {
    if (carrierOption.value === 'All' || this.state.filterBy !== 'By Carrier') carrierOption = {};

    if (this.state.filterBy === 'By Carrier') {
      this.setState({ carrierStatus: carrierOption })
    }

    this.setState({ selectStatus: selectedOption });
    const { filter, getNumbers, user, pagination, filterByNumber } = this.props;
    const { filterNumberValue } = this.state;
    const filterByCompany = filter ? filter.suggestion._id : null;
    const paginOptions = pagination
      ? { page: selectedOption.value === 'all' ? pagination.page : 1, limit: pagination.limit }
      : null;
    if (
      user.role === 'superAdmin' ||
      user.role === 'supportEngineer' ||
      user.role === 'companyGroupAdmin' ||
      user.role === 'companyGroupManager'
    ) {
      if (filterNumberValue !== '') {
        await filterByNumber(
          this.token,
          filterByCompany,
          filterNumberValue,
          paginOptions,
          selectedOption.value,
          carrierOption.value,
        );
      } else {
        await getNumbers(
          this.token,
          paginOptions,
          filterByCompany,
          selectedOption.value,
          carrierOption.value,
        );
      }
    } else {
      await this.props.getNumbers(
        this.token,
        paginOptions,
        user.company._id,
        selectedOption.value,
        carrierOption.value,
      );
    }
  };

  selectRoute = async (id, body, update) => {
    if (update) {
      const res = await this.props.updateNumberRoute(this.token, id, body);
      if (res) {
        this.handleChangePagination(this.pageNumber);
      }
    } else {
      this.editRouteReq = {
        token: this.token,
        id,
        body,
      };
    }
  };
  handleSortNumbers = filter => {
    const { sort } = this.state;
    const updateSort = { ...sort };

    if (updateSort.name === filter) {
      updateSort.order = updateSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      updateSort.name = filter;
      updateSort.order = 'asc';
    }
    this.setState({ sort: updateSort });
  };

  sortColumnByKey = array => {
    const { sort } = this.state;

    if (sort.name.indexOf('[') !== -1) {
      const sortNameArr = sort.name.replace(/[\[\]']+/g, ' ').split(' ');
      return orderBy(
        array,
        [
          el =>
            el[sortNameArr[0]] === null ? '' : el[sortNameArr[0]][sortNameArr[1]].toLowerCase(),
        ],
        [sort.order],
      );
    } else if (typeof array[0][sort.name] === 'string') {
      return orderBy(array, [el => el[sort.name].toLowerCase()], [sort.order]);
    } else {
      return orderBy(array, [el => el[sort.name]], [sort.order]);
    }
  };

  onForceUnlink = async () => {
    const { editNumberFieldChange, editedNumber, forceUnlinkNumberFromBox, addSystemLogs } = this.props;
    const changedNumber = { ...editedNumber };
    await editNumberFieldChange('linkedToObi', false);

    const resp = await forceUnlinkNumberFromBox(this.token, changedNumber?._id);

    if (resp) {
      const body = {
        actionType: 'system',
        description: `Number ${changedNumber?.number} force unlinked from box ${changedNumber?.linkedBox?.serialNumber}`,
      };
      await addSystemLogs(this.token, body);
    }

    this.setState({
      modalStatus: false,
      warningModal: false,
      isLoading: false,
      unassignSecurity: false,
    });
  };

  onShowLog = number => {
    this.setState({ showLogNumber: number, isShowLog: !this.state.isShowLog });
  };

  onShowLogCancel = () => {
    this.setState({ isShowLog: !this.state.isShowLog });
  };

  onUpdateBulkNumbers = async (type) => {
    const { selectedNumbers, pagination } = this.state;
    const { updateBulkNumbers, numbers,addSystemLogs } = this.props;

    if (selectedNumbers?.length === 0) {
        console.log('No numbers selected for bulk action');
        return;
    }

    this.setState({ isLoading: true });
    try {
        let requestBody = { numberIds: selectedNumbers, type };

        if (type === 'lockNumbers' || type === 'unLockNumbers') {
            requestBody.updateFields = null;
        } else if (type === 'unassign') {
            requestBody.updateFields = { company: null };
        }

        const res = await updateBulkNumbers(this.token, requestBody, pagination);
        
        if (res?.success) {
            const processed = numbers.allNumbers?.docs?.filter((number) => res?.alreadyProcessed?.includes(number?._id));
            const newlyProcessed = numbers.allNumbers?.docs?.filter((number) => res?.newlyProcessed?.includes(number?._id));
            const e911FailedNumbers = numbers.allNumbers?.docs?.filter((number) => res?.e911FailedNumbers?.includes(number?._id))
            
            const actionHeadings = {
              lockNumbers: 'Locked',
              unLockNumbers: 'Unlocked',
              unassign: 'Unassigned',
            };
            const actionHeading = actionHeadings[type] || '';
            if (processed?.length > 0) {
                const alreadyProcessedNumbers = processed.map(number => number?.number).join(', ');
                toast.error(`${actionHeading} Error: These numbers were already ${actionHeading}: ${alreadyProcessedNumbers}`);
            }

            if(e911FailedNumbers?.length){
              const errorMsg = e911FailedNumbers?.length === 1 ? `is connected to E911` : `are connected to E911`
              const numbers = e911FailedNumbers.map(number => number?.number).join(', ');
              toast.error(`Error: ${numbers} ${errorMsg}`);
            }

            if (newlyProcessed?.length > 0) {
                const newlyProcessedNumbers = newlyProcessed.map(number => number?.number).join(', ');
                toast.success(`${actionHeading} Success: These numbers were successfully ${actionHeading}: ${newlyProcessedNumbers}`);
                const body = {
                  actionType: 'system',
                  description: `Number ${actionHeading} Successfully: ${newlyProcessedNumbers}`,
                };
                await addSystemLogs(this.token, body);
            }
        } else {
          throw new Error(res?.error);
        }
    } catch (error) {
        console.error('Error performing bulk action:', error);
    }

    this.setState({
        modalStatus: false,
        warningModal: false,
        isLoading: false,
        unassignSecurity: false,
        selectedNumbers: [], 
        selectAllChecked: false,
    });

    await this.componentDidMount();
  };

  handleOnUnassignBulkNumbers = async () => {
    await this.onUpdateBulkNumbers('unassign', { company: null });
  }

  handleActionTypeChange = (actionType) => {
    if(actionType === 'unassign'){
      this.setState((prevState) => { 
        const selectedNumbers = [...prevState.selectedNumbers].filter(seltNumb => {
            const isNumber = this.props?.numbers?.allNumbers?.docs?.find(num => num?._id === seltNumb)
            if(isNumber && (isNumber?.type !== 'oob' && isNumber?.type !== 'callIdMask' && isNumber?.type !== 'tollFree'))
              return seltNumb
          
        })
        const selectAllChecked = selectedNumbers?.length > 0 && prevState?.selectAllChecked
         
        return { selectedNumbers, selectAllChecked, selectedBulkAction: actionType }
      })
    } else {
      const selectAllChecked = this.props?.numbers?.allNumbers?.docs?.every(
        (number) => this.state.selectedNumbers?.includes(number?._id)
      );
      this.setState({ selectAllChecked, selectedBulkAction: actionType })
    }
  };
  

  handleCheckboxChange = (numberId, isChecked) => {
    const { numbers } = this.props;
    const { selectedBulkAction } = this.state
    this.setState((prevState) => {
      let selectedNumbers = [...prevState.selectedNumbers];
      if (isChecked) {
        if (!selectedNumbers?.includes(numberId)) {
          selectedNumbers.push(numberId);
        }
      } else {
        selectedNumbers = selectedNumbers?.filter((id) => id !== numberId);
      }
      let selectAllChecked = false;
      if(selectedBulkAction === 'unassign'){
        selectAllChecked = numbers.allNumbers?.docs
        ?.filter((number) => number?.type !== 'oob' && number?.type !== 'callIdMask' && number?.type !== 'tollFree')
        .every((number) =>  selectedNumbers?.includes(number?._id));
      } else {
        selectAllChecked = this.props?.numbers?.allNumbers?.docs?.every(
          (number) => selectedNumbers?.includes(number?._id)
        );
      }
      return { selectedNumbers, selectAllChecked, selectedBulkAction: (selectedNumbers.length || prevState.selectedBulkAction) ? prevState.selectedBulkAction : '' };
    });
  };
  

  handleSelectAllChange = (isChecked) => {
    const { numbers } = this.props;
    const { selectedBulkAction } = this.state

    let selectedNumbers = [];
    if(selectedBulkAction === 'unassign' && isChecked){
      selectedNumbers = numbers.allNumbers?.docs
      ?.filter((number) => number?.type !== 'oob' && number?.type !== 'callIdMask' && number?.type !== 'tollFree')
      .map((number) => number._id);
    } else if (selectedBulkAction !== 'unassign' && isChecked) {
      selectedNumbers = numbers.allNumbers?.docs?.map((number) => number?._id);
    }
  
    this.setState({
      selectedNumbers,
      selectAllChecked: isChecked,
      selectedBulkAction: (selectedNumbers.length || selectedBulkAction) ? selectedBulkAction : '',
    });
  };
  

  handleBulkExecute = async () => {
    const { selectedBulkAction, selectedNumbers } = this.state;
    if ((selectedBulkAction === 'lockNumbers' || selectedBulkAction === 'unLockNumbers')  && selectedNumbers?.length > 0) {
      await this.onUpdateBulkNumbers(selectedBulkAction, null);
    }  else if (selectedBulkAction === 'unassign' && selectedNumbers?.length > 0) {
      this.setState({ warningModal: true }) 
    } else {
      console.log('No valid bulk action selected or no changes detected');
    }
  };
 
  render() {
    const { user, numbers, companies, filter, emails, gateways } = this.props;
    const { selectStatus, filterBy, carrierStatus, isNumbeDeleteSecurietyType, 
     selectedNumbers, selectAllChecked, selectedBulkAction, showEditBulkNumberModal } = this.state;
    if (!user || !user._id) {
      return <Redirect to="/login" />;
    }
    const { sort } = this.state;
    const renderList = sort.name.length
      ? numbers.allNumbers?.docs?.length && this.sortColumnByKey(numbers.allNumbers.docs)
      : numbers.allNumbers.docs;

    return (
      <div className="filter-section">
        {this.state.isLoading && <SpinnerCircles red />}
        <div className="filter-section numbers-tab" style={{ marginBottom: '20px' }}>
        <Row style={{ justifyContent: 'flex-end' }}>
            {(this.state.numberBulkActionsAccess === 'write' || this.state.numberBulkActionsAccess === 'both') &&  
              (selectedNumbers?.length > 0 || selectedBulkAction) && (
                <Col style={{ padding: 0, display: 'flex' }} md={{ size: 3 }}>
                  <span color="primary" className='bulk-action-text'>
                    Bulk Actions
                  </span>
                  <Input
                    type="select"
                    style={{ marginRight: '0', color: '#6c757d', background: '#f0f3f7', width: '150px' }}
                    onChange={(e) => this.handleActionTypeChange(e.target.value)}
                    value={selectedBulkAction}
                  >
                    <option value="" style={{ paddingTop: '10px', paddingBottom: '10px' }}></option>
                    {[
                        { value: 'lockNumbers', label: 'Number Lock' },
                        { value: 'unLockNumbers', label: 'Number Unlock' },
                        { value: 'unassign', label: 'Unassign' }
                    ].map(({ value, label }) => (
                        <option key={value} value={value}>{label}</option>
                    ))}
                  </Input>
                  <Button className="ml-2" color="primary" onClick={this.handleBulkExecute} 
                    disabled={!(selectedBulkAction && selectedNumbers?.length > 0)} >
                    Execute
                  </Button>
                </Col>
            )}
            {user.role === 'superAdmin' && (
              <Col
                md={{
                  size: 2,
                }}
              >
                <Button
                  className="float-right"
                  color="primary"
                  onClick={this.props.showAddNumber}
                >
                  New Number
                </Button>
              </Col>
            )}
            {(user.role === 'superAdmin' ||
              user.role === 'supportEngineer' ||
              user.role === 'companyGroupAdmin' ||
              user.role === 'companyGroupManager') && (
                <Col
                  style={{ display: 'flex', flexDirection: 'row', paddingRight: '0' }}
                  md={{ size: 2 }}
                >
                  <span className="icon-style">
                    <img style={{ height: '22px' }} src={FilterIcon} alt="filter" />
                  </span>
                  <Input
                    type="select"
                    style={{ marginRight: '0', color: '#6c757d', background: '#f0f3f7' }}
                    onChange={e => this.selectSearchFilter(e.currentTarget.value)}
                    id="number-filter-list"
                  >
                    {filterOptions.map(el => (
                      <option key={el} value={el} id={el === 'By Company' ? 'by-company' : el === 'By Number' ? 'by-number' : 'filter-option'}>
                        {el}
                      </option>
                    ))}
                  </Input>
                </Col>
              )}
            {filterBy === 'By Company' ? (
              <>
                {this.props.companies.docs && (
                  <Col md="2">
                    <FormGroup style={{ width: '100%', margin: '0px' }}>
                      <CompanyAutocomplete
                        searchTerm={filter !== null ? filter.value : null}
                        placeholder="Filter Company..."
                        companies={companies.docs}
                        onChange={this.onFilterByCompany}
                      />
                    </FormGroup>
                  </Col>
                )}
                {emails !== null && this.state.selectedCompany !== '' && (
                  <Col md="2">
                    <FormGroup style={{ width: '100%', margin: '0px' }}>
                      <UsersAutocomplete
                        searchTerm={emails.email}
                        placeholder="User Filter..."
                        users={emails.emails || []}
                        onChange={this.onUserTypeSelect}
                      />
                    </FormGroup>
                  </Col>
                )}
              </>
            ) : (
              <>
                {filterBy === 'By Carrier' ? (
                  <>
                    <Col md="2">
                      <DropdownSelect
                        options={carrierOptions}
                        selectedOption={carrierStatus}
                        onSelect={(obj) => this.onStatusSortSelect({}, obj)}
                      />
                    </Col>
                  </>
                ) : filterBy === 'By Temp DID' ? (
                  <Col md="2">
                    <DropdownSelect
                      options={yesNoOptions}
                      onSelect={this.onSelectTempDID}
                    />
                  </Col>
                ) : (
                  <Col md="2">
                    <Input
                      type="text"
                      placeholder={`Filter ${this.state.filterBy}`}
                      onChange={e => this.textSearchFilter(e.target.value)}
                      id="filter-by-number"
                    />
                  </Col>
                )}
              </>
            )}
            {filterBy === 'By Company' && (
              <Col md={{ size: 2 }} className="select-status dropdown-button">
                <span className="icon-style">
                  <img style={{ height: '22px' }} src={NumbersIcon} alt="number" />
                </span>
                <DropdownSelect
                  options={dropdownOptions}
                  selectedOption={selectStatus}
                  onSelect={this.onStatusSortSelect}
                />
              </Col>
            )}
            {/* <Col md="2" className="select-limit">
              <SetLimitEntries value={numbers.allNumbers.limit} onChange={this.handleSetLimit} />
            </Col> */}
          </Row>
        </div>
        <Container className="numbers-tab" fluid style={{ margin: '0' }}>
          <div className="viewContainer">
            <Row>
              <Col md={12}>
                {numbers.allNumbers && (
                  <AllNumbersList
                    selectRoute={(id, body, update = true) => {
                      this.selectRoute(id, body, update);
                    }}
                    user={user}
                    onDelete={number =>
                      this.setState({ modalStatus: true, isNumbeDeleteSecurietyType: number })
                    }
                    gateways={gateways}
                    numbers={renderList}
                    companies={companies.docs}
                    onAssignCompany={this.props.showAssignCompany}
                    onRevoke={this.props.showRevokeNumber}
                    onEdit={e => {
                      this.props.showEditNumber(e);
                     this.setState({ originalNumber: e });
                      this.props.assignRouteInfo(this.token, e._id);
                      this.props.getNumberFeaturesByID(this.token, e._id);
                    }}
                    onAssign={this.props.showAssignToNumber}
                    sortValue={sort}
                    onSort={this.handleSortNumbers}
                    onShowLog={this.onShowLog}
                    selectedBulkAction={selectedBulkAction}
                    selectedNumbers={selectedNumbers}
                    selectAllChecked={selectAllChecked}
                    onCheckboxChange={this.handleCheckboxChange}
                    onSelectAllChange={this.handleSelectAllChange}
                  />
                )}
              </Col>
            </Row>

            {numbers.allNumbers.totalPages > 0 && (
              <Row className="justify-content-md-center">
                <SetLimitEntries value={numbers.allNumbers.limit} onChange={this.handleSetLimit} />
                <Pagination
                  locale={ENG_LOCALE}
                  className="pagination-container"
                  onChange={this.handleChangePagination}
                  current={numbers.allNumbers.page}
                  total={numbers.allNumbers.totalDocs}
                  pageSize={numbers.allNumbers.limit}
                  showLessItems
                  showTitle={false}
                  showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                />
              </Row>
            )}

            <EditNumberModal
              selectRoute={(id, body, update = false) => {
                this.selectRoute(id, body, update);
              }}
              onForceUnlink={() => {
                this.setState({ modalStatus: true });
              }}
              gateways={gateways}
              isOpen={this.props.editNumberShow}
              onCancel={this.props.editNumberCancel}
              onConfirm={this.onEditNumber}
              onUnassign={() => {
                this.setState({ warningModal: true });
              }}
            />
            {this.state.showLogNumber && (
              <>
                <NumberChangeLog
                  number={this.state.showLogNumber}
                  isOpen={this.state.isShowLog}
                  onShowLogCancel={this.onShowLogCancel}
                ></NumberChangeLog>
              </>
            )}
            <WarningModal
                body={
                  (selectedBulkAction === 'unassign' && selectedNumbers?.length > 0) ? 
                  bulkUnAssignMsg : UnAssignMsg
              }
              isOpen={this.state.warningModal}
                onCancel={() => this.setState({ warningModal: false })}
                onConfirm={ () => {
                  if(selectedBulkAction === 'unassign' && selectedNumbers?.length > 0) {
                    this.handleOnUnassignBulkNumbers()
                  } else if(this.props.editNumberShow){
                    this.onSecurityModal()
                }}}
                yesButtonText="Proceed"
                noButtonText="Cancel"
              />
            <AddNumberModal
              isOpen={this.props.addNumberShow}
              onCancel={this.props.addNumberCancel}
              onConfirm={this.onAddNumber}
              onBulkConfirm={this.onBulkConfirm}
            />
            <AddSecurityCodeModal
              isOpen={this.state.unassignSecurity}
              onCancel={() => {
                this.setState({ unassignSecurity: false, warningModal: false });
              }}
              unassign
              onConfirm={this.onUnassignNumber}
              featureName={'unassign'}
            />
            <AddSecurityCodeModal
              isOpen={this.state.modalStatus}
              onCancel={() => {
                this.setState({ modalStatus: false, isNumbeDeleteSecurietyType: null });
              }}
              numberCode={isNumbeDeleteSecurietyType ? true : false}
              onConfirm={
                isNumbeDeleteSecurietyType
                  ? () => this.onDeleteNumber(isNumbeDeleteSecurietyType)
                  : this.onForceUnlink
              }
              // modalName={isNumbeDeleteSecurietyType?'deleteNumber':'forceunlink'}
              // featureName={isNumbeDeleteSecurietyType ? 'deleteNumber' : 'forceunlink'}// numberCode
              featureName={isNumbeDeleteSecurietyType ? 'numberCode' : 'unassign'} // numberCode
            />
            {/* <AssignNumberModal isOpen={this.props.assignNumberShow} onCancel={this.props.assignNumberCancel} onConfirm={this.onAssignToUser} /> */}
          </div>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  numbers: state.AppState.numbers,
  user: state.AppState.user,
  companies: state.AppState.companies,
  addNumberShow: state.UIState.numbers.addNumberShow,
  editNumberShow: state.UIState.numbers.editNumberShow,
  assignNumberShow: state.UIState.numbers.assignNumberShow,
  addedNumber: state.UIState.numbers.addNumber,
  editedNumber: state.UIState.numbers.editNumber,
  assignedUser: state.UIState.numbers.assignNumber,
  activeNumbersTab: state.UIState.numbers.activeNumbersTab,
  loadingUserNumbers: state.UIState.numbers.loadingUserNumbers,
  loadingCompanyNumbers: state.UIState.numbers.loadingCompanyNumbers,
  loadingAllNumbers: state.UIState.numbers.loadingAllNumbers,
  filter: state.UIState.numbers.filterNumbersByCompany.filter,
  pagination: state.UIState.numbers.filterNumbersByCompany.pagination,
  emails: state.UIState.numbers.filterNumbersByCompany.number,
  gateways: state.AppState.provisioning.gateways,
  boxDetails: state.AppState.boxDetails.box,
});

const mapDispatchToProps = dispatch => ({
  getNumbers: (token, pagination, id, type, carrier, tempDID) =>
    dispatch(getNumbers(token, pagination, id, type, null, carrier, tempDID)),
  getCompanies: (token, pagination, disablePaginate) =>
    dispatch(getCompanies(token, pagination, disablePaginate)),
  getCompanyNumbers: (token, id, uid, type) => dispatch(getCompanyNumbers(token, id, uid, type)),
  deleteNumberById: (token, id, number, pagination, filter, type) =>
    dispatch(deleteNumberById(token, id, number, pagination, filter, type)),
  getUserNumbers: (token, paginOptions, id) => dispatch(getUserNumbers(token, paginOptions, id)),
  showRevokeNumber: id => dispatch(revokeUserNumberShow(id)),
  revokeUserNumberCancel: () => dispatch(revokeUserNumberCancel()),
  showAssignCompany: id => dispatch(assignCompanyNumberShow(id)),
  showAssignCompanyCancel: () => dispatch(assignCompanyNumberCancel()),
  showEditNumber: id => dispatch(editNumberShow(id)),
  editNumberCancel: () => dispatch(editNumberCancel()),
  editNumber: (token, number, pagination, filter, type) =>
    dispatch(updateNumber(token, number, pagination, filter, type)),
  updateBulkNumbers: (token, number, pagination, filter, type) =>
    dispatch(updateBulkNumbers(token, number, pagination, filter, type)),
  setActiveNumbersTab: tabId => dispatch(setActiveNumbersTab(tabId)),
  showAddNumber: () => dispatch(showAddNumber()),
  addNumberCancel: () => dispatch(cancelAddNumber()),
  addNewNumber: (token, id, number, pagination, filter, type) =>
    dispatch(addNumber(token, id, number, pagination, filter, type)),
  showAssignToNumber: (token, id) => dispatch(assignNumberShow(token, id)),
  assignNumberCancel: () => dispatch(cancelAssignNumber()),
  assignToUser: (token, number, userId) => dispatch(assignNumberToUser(token, number, userId)),
  filterNumbersByCompany: filter => dispatch(filterNumbersByCompany(filter)),
  filterPagination: pagination => dispatch(filterPagination(pagination)),
  filterByNumber: (token, id, number, pagination, carrier) =>
    dispatch(filterByNumber(token, id, number, pagination, carrier)),
  filterByEmail: (token, number, pagination) => dispatch(filterByEmail(token, number, pagination)),
  updateObiByNumber: (token, obiNumber, body) =>
    dispatch(updateObiByNumber(token, obiNumber, body)),
  assignRouteInfo: (token, numId) => dispatch(assignRouteInfo(token, numId)),
  addBulkNumber: (token, body) => dispatch(addBulkNumber(token, body)),
  getGateways: token => dispatch(getGateways(token)),
  updateNumberRoute: (token, numId, body) => dispatch(updateNumberRoute(token, numId, body)),
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChangeAction(name, value)),
  getNumberFeaturesByID: (token, id) => dispatch(getNumberFeaturesByID(token, id)),
  getTrunkGroupList: token => dispatch(getTrunkGroupList(token)),
  addSystemLogs: (token, body) => dispatch(addSystemLogs(token, body)),
  forceUnlinkNumberFromBox: (token, numberId) => dispatch(forceUnlinkNumberFromBox(token, numberId)),
  uploadAgreementFile: (token, id, files) => dispatch(uploadAgreementFile(token, id, files)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WithUserData(Numbers));
